import {Stack, Divider, Typography, Button, Tooltip, Box, Alert} from "@mui/material"
import DialogPhone from "./DialogPhone"
import {Fragment, useEffect, useState} from "react"
import AddIcon from "@mui/icons-material/Add";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {BotonEditar} from "../../../components/Buttons";
import {FontSubtitleTwo} from "../../../components/SharedTypography";
import {HttpClientPhone} from "../../../../../http/client/httpClient";
import {useAction} from "../../../../../hooks/useAction";
import {ClientPhoneNumber, ClientPhoneNumberFields, PhoneTypes} from "../../../../../types/client/clientData";

const TEXTOS = {
    TELEFONOS: "Teléfonos",
}

interface PhonesProps {
    clientId: number,
    canEdit?: boolean,
    isPhyisicalPerson?: boolean,
    updatePhones?: (a: boolean) => void
}

const Phones = ({clientId, canEdit, isPhyisicalPerson, updatePhones}: PhonesProps) => {
    const [togglePhone, setTogglePhone] = useState<boolean>(false)
    const [defaultPhones, setDefaultPhones] = useState<ClientPhoneNumber[]>()
    const [phoneNumberInDialog, setPhoneNumberInDialog] = useState<ClientPhoneNumber | undefined>(undefined)
    const {snackbarSuccess} = useAction()

    const handleAddPhone = () => {
        setTogglePhone(true)
    }

    const handleEditPhone = (phone: ClientPhoneNumber) => {
        setPhoneNumberInDialog(phone)
        setTogglePhone(true)
    }
    
    const onClose = () => {
        setPhoneNumberInDialog(undefined)
        setTogglePhone(false)
    }
    
    const loadPhones = () => {
        HttpClientPhone.getByIdClient(clientId).then((r) => {
            setDefaultPhones(r)
            if (r && r?.length !== 0 && updatePhones) updatePhones(true)
            const hasCellphone = r.some((p) => p[ClientPhoneNumberFields.PhoneTypeCode] === PhoneTypes.Celular)
            const hasParticular = r.some((p) => p[ClientPhoneNumberFields.PhoneTypeCode] === PhoneTypes.Particular)
            if (isPhyisicalPerson && (hasCellphone || hasParticular)) updatePhones && updatePhones(true)
            if (!isPhyisicalPerson && hasCellphone && hasParticular) updatePhones && updatePhones(true)
        })
    }
    
    useEffect(() => {
        loadPhones()
    }, [clientId])
    
    const handleSubmit = () => {
        snackbarSuccess('El teléfono fue guardado correctamente')
        loadPhones()
    }

    return (
        <Fragment>
            {
                defaultPhones &&
                <Fragment>
                            <Stack spacing={4}>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                    <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                        <FontSubtitleTwo text={TEXTOS.TELEFONOS} />
                                        {
                                            canEdit &&
                                            <Tooltip title={"Se considera número de Argentina. Si no posee uno particular, puede registrar de un tercero"}>
                                                <HelpOutlineIcon fontSize={"small"} color="info"/>
                                            </Tooltip>
                                        }
                                    </Stack>
                                    {
                                        canEdit &&
                                        <Button size="small" color='primary' variant='contained' onClick={handleAddPhone} startIcon={<AddIcon fontSize={"small"} />}>
                                            Agregar teléfono
                                        </Button>
                                    }
                                </Stack>
                                <Divider />
                                <Stack spacing={4}>
                                {
                                    defaultPhones.length !== 0 ?
                                    defaultPhones.map((p, idx) => (
                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} key={idx}>
                                            <Stack>
                                                <Typography fontSize={15} fontWeight={550}>{`Teléfono ${p[ClientPhoneNumberFields.PhoneTypeDesc]}`}</Typography>
                                                <Typography fontSize={14} color='#7e8299'>{`${p[ClientPhoneNumberFields.PhoneNumberWithAreaCode]}`}</Typography>
                                            </Stack>
                                            {
                                                canEdit &&
                                                <BotonEditar onClick={() => {handleEditPhone(p)}} />
                                            }
                                        </Stack>
                                    ))
                                    :
                                    <Box sx={{width: '100%'}}><Alert severity={'info'}>Aún no hay teléfonos cargados</Alert></Box>
                                }
                                </Stack>
                            </Stack>
                    {
                        canEdit &&
                        <DialogPhone
                            open={togglePhone}
                            onClose={onClose}
                            phoneTitle={phoneNumberInDialog ? 'Editar teléfono' : 'Nuevo teléfono'}
                            phone={phoneNumberInDialog && phoneNumberInDialog}
                            clientId={clientId}
                            onSubmitDialog={handleSubmit}
                        />
                    }
                </Fragment>
            }
        </Fragment>
    )
}

export default Phones